export default "__VITE_ASSET__DQVWBN2N__"